export const metaInfo = {
  name: "sample-app",
  version: "6.2.5",
  type: "sample",
  platform: "React",
};
